<template>
  <div>
    <div class="boxForm_header">
      <h1 class="boxForm_heading">
        <slot name="header"></slot>
      </h1>
    </div>
    <slot name="subheader" />
    <slot></slot>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  name: 'BaseNewForm'
}
</script>
